import React, { Component } from 'react';
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';
import AppAdditionalInfos from './AppAdditionalInfos';
import Ad from './Ad';
import Calendar from './Calendar';
import NavigationYear from './NavigationYear';
import './App.css';
import { Link } from 'react-router-dom';
import {getRegionShortName, getRegionFullName, getRegionURLString} from "./Helper/functions";
import axios from 'axios';
import MetaData from './SEO/MetaData';

const token = 'vPQzovwdrzZJ7LDGaMeiCKi3W';

class App extends Component {

	constructor(props) {
		super(props);

		this.state = {
			dateType: this.props.match.params.region ? 2 : 1,
			data: {},
			showSubNavi: false
		}

		this.handleChangeRegion = this.handleChangeRegion.bind(this);
		this.handleChangeType = this.handleChangeType.bind(this);
		this.onMouseoutSubnavi = this.onMouseoutSubnavi.bind(this);
		this.onMouseoverSubnavi = this.onMouseoverSubnavi.bind(this);
	}

	componentDidMount() {


		let url = 'https://www.feiertage-oesterreich.at/api/dates/?token='+token+'&region='+getRegionShortName(this.props.match.params.region)+'&year=' + this.props.match.params.year;

		axios.post(url)
			.then((response) => {
				this.setState(()=>{
					return {
						data: response.data
					}
				})
			})
			.catch((error) => {
				console.log(error);
			});
	}

	componentWillUpdate(nextProps, nextState){

		if(this.props.match.params.year !== nextProps.match.params.year || this.props.match.params.region !== nextProps.match.params.region) {
			this.props = nextProps;

			this.handleChangeType((this.props.match.params.region) ? 2 : 1);

			let url = 'https://www.feiertage-oesterreich.at/api/dates/?token='+token+'&region='+getRegionShortName(this.props.match.params.region)+'&year=' + this.props.match.params.year;

			axios.post(url)
				.then((response) => {
					this.setState(()=>{
						return {
							data: response.data
						}
					})
				})
				.catch((error) => {
					console.log(error);
				});
		}
	}

	componentDidUpdate(prevProps){
		if (this.props.match.params.year !== prevProps.match.params.year || this.props.match.params.region !== prevProps.match.params.region) {
			/*ReactGA.ga('send', 'pageview', {
				'page': window.location.pathname + window.location.search,
				'location': window.location.href,
				'title': document.title
			});*/
		}
	}

	handleChangeRegion(event) {
		this.handleChangeType(2);
		this.setState(() => {
			return {
				showSubNavi: false
			}
		})
	}

	handleChangeType(type) {
		this.setState(() => {
			return {
				dateType: type
			}
		})
	}

	onMouseoverSubnavi(event) {
		this.setState(() => {
			return {
				showSubNavi: true
			}
		})
	}

	onMouseoutSubnavi(event) {
		this.setState(() => {
			return {
				showSubNavi: false
			}
		})
	}

	render() {

        return (

          <div className="App">

			  <MetaData year={parseInt(this.props.match.params.year, 10)} region={this.props.match.params.region} dateType={this.state.dateType} />

			  <AppHeader year={parseInt(this.props.match.params.year, 10)} />

			  <Ad type="leaderboard" />

			  <main className="container">

				  <NavigationYear year={parseInt(this.props.match.params.year, 10)} region={this.props.match.params.region} onDecrement={this.props.onDecrement} onIncrement={this.props.onIncrement} />

				  <ul className="NavigationMain">
					  <li className={'public-holidays' + (this.props.match.params.region ? '' : ' active')}>

						  <Link to={'/' + this.props.match.params.year + '/'} className="button" onClick={()=>this.handleChangeType(1)}>Feiertage</Link>
					  </li>

					  <li className={'school-holidays' + (this.props.match.params.region ? ' active' : '') + (this.state.showSubNavi === true ? '  show' : '')} onMouseOver={this.onMouseoverSubnavi} onMouseOut={this.onMouseoutSubnavi}>
						  <span className="button">Schulferien{(this.props.match.params.region ? ': ' + getRegionFullName(this.props.match.params.region) : '')}</span>
						  <ul>
							  <li><Link to={'/' + this.props.match.params.year + '/schulferien/' + getRegionURLString('B') + '/'} onClick={() => this.handleChangeRegion("B")}>Burgenland</Link></li>
							  <li><Link to={'/' + this.props.match.params.year + '/schulferien/' + getRegionURLString('K') + '/'} onClick={() => this.handleChangeRegion("K")}>Kärnten</Link></li>
							  <li><Link to={'/' + this.props.match.params.year + '/schulferien/' + getRegionURLString('NÖ') + '/'} onClick={() => this.handleChangeRegion("NÖ")}>Niederösterreich</Link></li>
							  <li><Link to={'/' + this.props.match.params.year + '/schulferien/' + getRegionURLString('OÖ') + '/'} onClick={() => this.handleChangeRegion("OÖ")}>Oberösterreich</Link></li>
							  <li><Link to={'/' + this.props.match.params.year + '/schulferien/' + getRegionURLString('S') + '/'} onClick={() => this.handleChangeRegion("S")}>Salzburg</Link></li>
							  <li><Link to={'/' + this.props.match.params.year + '/schulferien/' + getRegionURLString('St') + '/'} onClick={() => this.handleChangeRegion("St")}>Steiermark</Link></li>
							  <li><Link to={'/' + this.props.match.params.year + '/schulferien/' + getRegionURLString('T') + '/'} onClick={() => this.handleChangeRegion("T")}>Tirol</Link></li>
							  <li><Link to={'/' + this.props.match.params.year + '/schulferien/' + getRegionURLString('V') + '/'} onClick={() => this.handleChangeRegion("V")}>Vorarlberg</Link></li>
							  <li><Link to={'/' + this.props.match.params.year + '/schulferien/' + getRegionURLString('W') + '/'} onClick={() => this.handleChangeRegion("W")}>Wien</Link></li>
						  </ul>
					  </li>

				  </ul>

				  <Calendar year={parseInt(this.props.match.params.year, 10)} region={this.props.match.params.region} dateType={this.state.dateType} data={this.state.data} />

				  <AppAdditionalInfos year={parseInt(this.props.match.params.year, 10)} region={this.props.match.params.region} dateType={this.state.dateType} data={this.state.data} />

			  </main>

			  <AppFooter />
          </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js